import React, { useState } from "react";

const ReadMoreText = ({ fullText }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxChars = 220;

  const isLongText = fullText.length > maxChars;
  const previewText = fullText.slice(0, maxChars);
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <p>
      {isExpanded || !isLongText ? fullText : `${previewText}... `}
      {isLongText && (
        <button onClick={toggleReadMore} className="mcb-more">
          {isExpanded ? "Less" : "More"}
        </button>
      )}
    </p>
  );
};

export default ReadMoreText;
